import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { DashboardInfoModel } from '../../../model/builk/dashboard/dashboard-info.model';
import { Observable } from 'rxjs';
import { apiLink } from '../../../constant/api-link';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) { }

  sub: any;

  getDashboardInfo(): Observable<DashboardInfoModel> {
    const url = apiLink.getDashboardInfo;
    // const params = new HttpParams().set("userEmail", userEmail);
    this.sub = this.http.get<DashboardInfoModel>(url);
    return this.sub;
  }

  getPeriodDashboardInfo(startDate: Date, endDate: Date): Observable<DashboardInfoModel> {
    const url = apiLink.getPeriodDashboardInfo;
    const params = new HttpParams()
    .set("startDate", startDate.toISOString())
    .set("endDate", endDate.toISOString());
    this.sub = this.http.get<DashboardInfoModel>(url, { params: params });
    return this.sub;
  }
}
